import { GTM_CONTAINER_ID } from './config';

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

let loaded = false;

/**
 * Injects the Google Tag Manager container script.
 *
 * GTM is the umbrella that cascades to GA4, Google Ads, Facebook Pixel and
 * TikTok — ~650 KB of analytics/marketing JS, almost none of which is needed
 * for first paint. Previously the snippet ran synchronously in `<head>`, so
 * `gtm.js` and everything it loads fought the Vue app for the main thread and
 * delayed FCP/LCP/TTI. We now defer the injection off the critical render path
 * (see `runWhenIdleOrInteraction`); `dataLayer` is created here so the
 * `gtm.start` event is still recorded the moment the container loads.
 *
 * Idempotent: subsequent calls are no-ops.
 */
export const loadGoogleTagManager = (): void => {
  if (loaded) {
    return;
  }
  loaded = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;
  document.head.appendChild(script);
};
